import { ApiService } from './api.service';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import {DispatchItemToExport, Trip} from '../models';
import { Session } from '../interfaces';
import { environment } from '../../../environments/environment';
import { SnackbarService } from '../../shared/components/snackbar/snackbar.service';
import { HttpHeaders } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class TripService {

  constructor(private apiService: ApiService, private snackbarService: SnackbarService) {

  }

  /** Cargar uno o mas viajes al 100% */
  loadTrip(request): Observable<any> {
    return this.apiService.put(this.apiService.trips + '/load', request).pipe();
  }

  /** Retirar un despacho de un viaje */
  rejectDispatchWithdrawal(idTrip, request): Observable<any> {
    return this.apiService.put(this.apiService.dispatch + '/trip/' + idTrip + '/cancel', request).pipe();
  }

  /** Confirmar un viaje a transito */
  confirmTravel(body): Observable<any> {
    return this.apiService.put(this.apiService.trips, body).pipe();
  }

  /** Confirmar un viaje a transito */
  resendBeetrack(body): Observable<any> {
    return this.apiService.put(this.apiService.resend, body).pipe();
  }

  /** Rechazar un viaje */
  saveRejectTrip(request): Observable<any> {
    return this.apiService.put(this.apiService.dispatch + '/event', request).pipe();
  }

  /** Obtener la hoja de carguía */
  getCargio(request): Observable<any> {
    return this.apiService.put(this.apiService.dispatch + '/tripsguide', request).pipe();
  }

  /** Obtener la lista de impresoras */
  getPrinters(guidePlatform, code): Observable<any> {
    return this.apiService.get(`${this.apiService.report}/print/printers/${guidePlatform}/${code}`)
      .pipe()
  }

  /** Impresión de guía */
  getPrintGuide(request): Observable<any> {
    const headers =  { headers: new HttpHeaders({ timeout: `${150000}` })};
    this.snackbarService.show('Imprimiendo! Por favor espere a que el proceso termine.','info', {duration: 150000})
    return this.apiService
    .post(`${this.apiService.report}/print`, request)
    .pipe(map(response => {
      this.snackbarService.hide();
      return response;
    }))
  }

  /** Reimprimir guía */
  reprintGuide(request): Observable<any> {
  const headers = { headers: new HttpHeaders({ timeout: `${150000}`})};
    return this.apiService
      .post(`${this.apiService.report}/print`, request, request).pipe();
  }

  /** Reporte de lista de guías */
  searchReprintGuide(filters: string): Observable<any> {
    const api = this.apiService.report + '/print/documents/?' + filters;
    return this.apiService.get(api).pipe();
  }

  /** Cambiar el estado de un viaje */
  changeStateTrip(request): Observable<any> {
    return this.apiService.put(this.apiService.dispatch + `/trip/status/${request.tripId}/${request.statusId}`
    ).pipe();
  }

  /** Reporte la lista de viajes */
  filterTrips(request): Observable<Trip[]> {
    return this.apiService.get(this.apiService.businessDispatchRead + '/dispatches/trips?' + request)
      .pipe();
  }


  /** Lista de codigos de viajes de una entidad */
  getTripsCode(entityCode): Observable<any> {
    return this.apiService.get(this.apiService.dispatch + `/tripscode?entityCode=${entityCode}`
    ).pipe();
  }

  /** Retorna la lista estados del viaje */
  getTripsState(): Observable<any> {
    const session: Session = JSON.parse(
      localStorage.getItem(environment.sessionAuth)
    );
    if (session && session.tripState) {
      return of(session.tripState);
    } else {
      return this.apiService.get(this.apiService.businessDispatchRead + '/simpleparameters/1')
        .pipe(
          map(data => {
            session.tripState = data;
            localStorage.setItem(
              environment.sessionAuth,
              JSON.stringify(session)
            );
            return data
          })
        );
      }
  }

  /** Retorna la lista tipos del viaje */
  getTripsType(): Observable<any> {
    const session: Session = JSON.parse(
      localStorage.getItem(environment.sessionAuth)
    );
    if (session && session.tripType) {
      return of(session.tripType);
    } else {
      return this.apiService.get(this.apiService.businessDispatchRead + '/simpleparameters/22')
        .pipe(
          map(data => {
            session.tripType = data;
            localStorage.setItem(
              environment.sessionAuth,
              JSON.stringify(session)
            );
            return data
          })
        );
      }
  }

  /** Obtiene la lista de detalles de un viaje */
  getTripDetail(dispatchTripId): Observable<any> {
    return this.apiService.get(this.apiService.businessDispatchRead + `/dispatches/trip-dispatches/configurations?dispatchTripId=${dispatchTripId}`
    ).pipe(
      map(data=>{
        if(data){
          return [data];
        }else{
          return [];
        }
      })
    );
  }

  /** Retorna la lista de razones del rechazo del viaje */
  getListReazon(): Observable<any> {
    return this.apiService.get(`${environment.apiConfiguration}/group/REJECTION_REASON_CONFIG`);
  }

  sortCarriers(carriers){
    return carriers.sort((a, b) => {
      if (a.businessName > b.businessName) {
        return 1;
      }
      if (a.businessName < b.businessName) {
        return -1;
      }
      return 1;
    })
  }

  /** Agregar despachos a viaje creado */
  addDispatchToTrip(request): Observable<any> {
    return this.apiService.post(this.apiService.addDispatchToTrip, request)
      .pipe();
  }

  /** Reporte la lista de viajes enlazado a despacho */
  filterDispatchTrips(request): Observable<DispatchItemToExport[]> {
    return this.apiService.get(this.apiService.businessDispatchRead + '/dispatches/trips/items?' + request)
      .pipe();
  }

}
